import { emailOf, logout } from "../auth/auth.js";
import { navigate } from "../router.js";
import { escapeHtml } from "./dom.js";

// Display gate for the Results nav link only. Real authorization is enforced by the
// quiz-results Lambda (ADMIN_EMAILS); this just hides a link from non-admins.
const ADMINS = (import.meta.env.VITE_ADMIN_EMAILS ?? "")
  .split(",")
  .map((e) => e.trim().toLowerCase())
  .filter(Boolean);

/** Render the v1-style fixed nav + footer and return the #content mount. */
export async function shell(root: HTMLElement, active: string): Promise<HTMLElement> {
  const email = (await emailOf()) ?? "";
  const isAdmin = ADMINS.includes(email);
  const initial = (email.trim()[0] ?? "?").toUpperCase();
  const tab = (id: string, label: string) =>
    `<button class="nav-btn${active === id ? " active" : ""}" data-nav-to="/${id}">${label}</button>`;

  root.innerHTML = `
    <nav class="site-nav">
      <div class="nav-container">
        <span class="logo" data-nav-to="/files"><span class="b">Bright Mind</span> <span class="g">Tech</span></span>
        <div class="nav-right">
          ${tab("files", "Files")}
          ${tab("quiz", "Quiz")}
          ${isAdmin ? tab("results", "Results") : ""}
          <div class="avatar-wrap" id="avatarWrap">
            <button class="avatar" id="avatarBtn" aria-label="Account menu">${escapeHtml(initial)}</button>
            <div class="avatar-menu" id="avatarMenu">
              <div class="avatar-menu-email">${escapeHtml(email)}</div>
              <button class="avatar-menu-item" id="signOut">Sign Out</button>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <main id="content" class="content"></main>
    <footer class="site-ftr">© 2026 Bright Mind Tech. All rights reserved.</footer>`;

  root.querySelectorAll<HTMLElement>("[data-nav-to]").forEach((el) =>
    el.addEventListener("click", () => navigate(el.getAttribute("data-nav-to") ?? "/files")),
  );

  const menu = root.querySelector<HTMLElement>("#avatarMenu");
  const wrap = root.querySelector<HTMLElement>("#avatarWrap");
  root.querySelector<HTMLButtonElement>("#avatarBtn")?.addEventListener("click", (e) => {
    e.stopPropagation();
    menu?.classList.toggle("open");
  });
  document.addEventListener("click", (e) => {
    if (wrap && !wrap.contains(e.target as Node)) menu?.classList.remove("open");
  });
  root.querySelector<HTMLButtonElement>("#signOut")?.addEventListener("click", () => {
    void logout();
  });

  const content = root.querySelector<HTMLElement>("#content");
  if (!content) throw new Error("content mount missing");
  return content;
}
